/*
 * Muscle SVG path data — vendored (offline) from "Body Muscles" by Ivan Vulović.
 * Source: https://github.com/vulovix/body-muscles  ·  License: Apache-2.0
 * See ../LICENSE-body-muscles.txt and ../NOTICE-body-muscles.txt.
 * Adaptations: TypeScript -> JS; ViewSide enum -> "front"/"back".
 * Coord space: FRONT viewBox "0 0 35 93", BACK viewBox "37 0 35 93".
 */

/**
 * Back (Posterior) view muscle definitions
 * All muscle paths with x > 35 in the SVG coordinate system
 */
export const BACK_MUSCLES = [
  {
    id: "head-back",
    name: "Head (Posterior)",
    view: "back",
    path: "m 48.157455,6.3585449 0.44208,-0.14964 0.16111,0.16427 1.48163,4.0475101 2.32401,1.45118 2.39971,-1.52387 0.97577,-3.6896901 0.52752,-0.55908 0.23367,0.0981 0.24198,-3.34467 -2.03129,-2.31103004 -2.84509,-0.51629 -2.20422,0.52915 -1.93631,2.63077004 z",
  },
  {
    id: "nape",
    name: "Nape",
    view: "back",
    path: "m 52.369695,12.105075 -2.35767,-1.55045 -1.47119,-3.9514301 -0.60741,0.0403 0.27409,1.82447 0.97635,0.33932 0.7613,2.2157201 0.33017,1.06849 0.0895,2.14894 1.16448,0.008 0.10563,-0.70833 0.54716,-0.0606 z m 1.01793,1.47595 0.23768,0.64982 1.38107,-0.004 0.01,-2.38784 0.25971,-0.79061 0.57215,-2.1698001 0.76359,-0.41018 0.25158,-1.78416 -0.62859,0.0193 -1.08488,3.8998101 -2.39725,1.46684 0.2768,1.48507 z",
  },
  {
    id: "traps-upper-left",
    name: "Left Trapezius (Upper)",
    view: "back",
    path: "M 49.625,14.629 L 49.688,12.005 L 48.974,13.157 L 44.594,14.654 L 45.945,16.925 L 51.222,16.925 L 51.183,14.550 Z",
  },
  {
    id: "traps-mid-left",
    name: "Left Trapezius (Mid)",
    view: "back",
    path: "M 46.034,17.075 L 48.920,21.925 L 51.303,21.925 L 51.224,17.075 Z",
  },
  {
    id: "traps-lower-left",
    name: "Left Trapezius (Lower)",
    view: "back",
    path: "M 49.009,22.075 L 49.572,23.022 L 51.403,28.104 L 51.305,22.075 Z",
  },
  {
    id: "traps-upper-right",
    name: "Right Trapezius (Upper)",
    view: "back",
    path: "M 55.439,14.729 L 55.376,12.104 L 56.090,13.256 L 60.470,14.754 L 59.179,16.925 L 53.844,16.925 L 53.881,14.649 Z",
  },
  {
    id: "traps-mid-right",
    name: "Right Trapezius (Mid)",
    view: "back",
    path: "M 59.089,17.075 L 56.204,21.925 L 53.763,21.925 L 53.842,17.075 Z",
  },
  {
    id: "traps-lower-right",
    name: "Right Trapezius (Lower)",
    view: "back",
    path: "M 56.114,22.075 L 55.492,23.121 L 53.661,28.203 L 53.761,22.075 Z",
  },
  {
    id: "lats-upper-left",
    name: "Left Lats (Upper)",
    view: "back",
    path: "M 44.144,15.285 L 39.888,20.286 L 39.426,22.749 L 41.263,21.510 L 44.025,20.355 L 45.663,23.400 L 49.103,23.400 Z",
  },
  {
    id: "deltoid-rear-left",
    name: "Left Rear Deltoid",
    view: "back",
    path: "M 42.201,16.586 L 40.626,18.152 L 39.736,20.156 L 43.992,15.155 Z",
  },
  {
    id: "lats-mid-left",
    name: "Left Lats (Mid)",
    view: "back",
    path: "M 45.771,23.600 L 45.872,23.789 L 47.009,29.286 L 47.023,30.400 L 51.080,30.400 L 51.053,28.314 L 49.185,23.600 Z",
  },
  {
    id: "lats-lower-left",
    name: "Left Lats (Lower)",
    view: "back",
    path: "M 47.026,30.600 L 47.086,35.145 L 51.156,36.255 L 51.082,30.600 Z",
  },
  {
    id: "deltoid-rear-right",
    name: "Right Rear Deltoid",
    view: "back",
    path: "M 62.863,16.686 L 64.438,18.251 L 65.328,20.255 L 61.073,15.254 Z",
  },
  {
    id: "lats-upper-right",
    name: "Right Lats (Upper)",
    view: "back",
    path: "M 60.921,15.384 L 65.176,20.385 L 65.290,22.849 L 63.801,21.609 L 61.039,20.454 L 59.455,23.400 L 56.022,23.400 Z",
  },
  {
    id: "lats-mid-right",
    name: "Right Lats (Mid)",
    view: "back",
    path: "M 59.347,23.600 L 59.192,23.888 L 58.055,29.385 L 58.042,30.400 L 53.986,30.400 L 54.012,28.413 L 55.918,23.600 Z",
  },
  {
    id: "lats-lower-right",
    name: "Right Lats (Lower)",
    view: "back",
    path: "M 58.039,30.600 L 57.979,35.245 L 53.908,36.354 L 53.983,30.600 Z",
  },
  {
    id: "triceps-long-left",
    name: "Left Triceps (Long Head)",
    view: "back",
    path: "M 43.593,21.039 L 44.920,23.967 L 43.615,25.653 L 43.186,27.069 L 39.209,29.802 Z",
  },
  {
    id: "triceps-lateral-left",
    name: "Left Triceps (Lateral Head)",
    view: "back",
    path: "M 43.459,20.972 L 39.075,29.735 L 38.871,25.461 L 39.407,23.674 L 41.242,21.927 Z",
  },
  {
    id: "hand-back-left",
    name: "Left Hand (Back)",
    view: "back",
    path: "M 40.716955,42.424835 l -1.5182,0.0863 -0.78184,-0.65295 -1.16168,2.1855 -0.78414,3.34805 0.49892,0.20949 0.54632,-2.2158 0.50597,0.24175 -0.29779,2.5019 0.62936,0.22875 0.35546,-2.50096 0.56242,0.16536 -0.16126,2.77057 0.77674,0.30455 0.19056,-2.87291 0.45724,-0.0289 0.22827,2.64778 0.66597,0.24774 -0.0359,-4.56685 0.33693,-0.20224 1.39227,1.65147 0.32017,-0.35115 -0.77444,-2.03749 z",
  },
  {
    id: "forearm-flexors-left",
    name: "Forearm Flexors Left",
    view: "back",
    path: "M 40.775,29.006 L 42.870,27.644 L 42.187,29.635 L 42.603,34.383 L 40.799,42.081 L 39.814,42.253 Z",
  },
  {
    id: "forearm-extensors-left",
    name: "Forearm Extensors Left",
    view: "back",
    path: "M 39.665,42.242 L 38.305,41.501 L 37.998,34.491 L 38.635,31.429 L 39.245,30.209 L 40.625,28.994 Z",
  },
  {
    id: "triceps-long-right",
    name: "Right Triceps (Long Head)",
    view: "back",
    path: "M 61.376,21.213 L 60.056,24.145 L 61.330,26.199 L 61.657,27.251 L 65.780,29.966 Z",
  },
  {
    id: "triceps-lateral-right",
    name: "Right Triceps (Lateral Head)",
    view: "back",
    path: "M 61.510,21.146 L 65.914,29.899 L 66.108,25.624 L 65.568,23.839 L 63.729,22.096 Z",
  },
  {
    id: "hand-back-right",
    name: "Right Hand (Back)",
    view: "back",
    path: "M 64.301385,42.592325 l 1.51839,0.0828 0.78033,-0.65476 1.16673,2.18281 0.79187,3.34623 -0.49843,0.21064 -0.55144,-2.21453 -0.50541,0.24292 0.30356,2.5012 -0.62882,0.23021 -0.36124,-2.50014 -0.56203,0.16666 0.16765,2.77019 -0.77603,0.30634 -0.19719,-2.87245 -0.45732,-0.0278 -0.22215,2.64829 -0.66539,0.24928 0.0254,-4.56692 -0.3374,-0.20146 -1.38845,1.65469 -0.32098,-0.35041 0.76973,-2.03928 z",
  },
  {
    id: "forearm-flexors-right",
    name: "Forearm Flexors Right",
    view: "back",
    path: "M 65.204,42.420 L 63.925,29.007 L 61.764,27.798 L 62.786,29.733 L 62.397,34.555 L 64.219,42.248 Z",
  },
  {
    id: "forearm-extensors-right",
    name: "Forearm Extensors Right",
    view: "back",
    path: "M 64.075,28.993 L 65.353,42.405 L 66.712,41.663 L 67.002,34.653 L 66.358,31.591 L 65.745,30.373 Z",
  },
  {
    id: "spine",
    name: "Spine",
    view: "back",
    path: "m 51.733705,14.788555 0.53876,25.33066 0.48967,-0.0297 0.65658,-25.3387 -0.28147,-0.84188 -1.25059,-4.9e-4 z",
  },
  {
    id: "lower-back-erectors-left",
    name: "Erector Spinae Left",
    view: "back",
    path: "M 52.100,37.310 L 49.537,36.465 L 50.244,40.788 L 52.200,42.030 L 52.200,40.270 L 52.150,40.280 Z",
  },
  {
    id: "lower-back-ql-left",
    name: "Quadratus Lumborum Left",
    view: "back",
    path: "M 49.389,36.490 L 46.240,35.460 L 44.720,39.420 L 50.096,40.812 Z",
  },
  {
    id: "lower-back-erectors-right",
    name: "Erector Spinae Right",
    view: "back",
    path: "M 52.800,42.030 L 52.800,40.270 L 52.850,40.260 L 52.900,37.290 L 55.289,36.625 L 54.805,40.801 Z",
  },
  {
    id: "lower-back-ql-right",
    name: "Quadratus Lumborum Right",
    view: "back",
    path: "M 55.439,36.643 L 55.980,36.470 L 58.320,35.720 L 59.660,39.450 L 54.955,40.819 Z",
  },
  {
    id: "gluteus-medius-left",
    name: "Gluteus Medius Left",
    view: "back",
    path: "M 50.191,41.481 L 44.740,39.690 L 43.830,41.580 L 43.431,44.301 Z",
  },
  {
    id: "gluteus-maximus-left",
    name: "Gluteus Maximus Left",
    view: "back",
    path: "M 50.249,41.619 L 43.489,44.439 L 44.410,50.520 L 47.180,51.030 L 51.620,49.090 L 52.200,49.480 L 52.200,42.880 Z",
  },
  {
    id: "gluteus-medius-right",
    name: "Gluteus Medius Right",
    view: "back",
    path: "M 55.274,41.079 L 61.354,45.519 L 60.640,42.150 L 59.740,39.860 Z",
  },
  {
    id: "gluteus-maximus-right",
    name: "Gluteus Maximus Right",
    view: "back",
    path: "M 55.186,41.201 L 52.800,42.880 L 52.800,49.480 L 53.570,49.090 L 57.680,50.760 L 60.500,50.600 L 61.266,45.641 Z",
  },
  {
    id: "knee-back-left",
    name: "Left Back Knee",
    view: "back",
    path: "m 51.176145,64.073985 -1.20605,3.01461 0.70738,0.26558 0.89754,3.51771 -0.55801,-4.01191 z m -5.08496,-3.15003 0.63355,1.8609 0.16813,2.03261 0.61314,1.93117 -0.90585,-0.0851 -0.28534,2.15982 z",
  },
  {
    id: "knee-back-right",
    name: "Right Back Knee",
    view: "back",
    path: "m 54.019305,64.073985 1.20605,3.01461 -0.70737,0.26558 -0.89755,3.51771 0.55802,-4.01191 z m 5.08496,-3.15003 -0.63355,1.8609 -0.16813,2.03261 -0.61313,1.93117 0.90584,-0.0851 0.28534,2.15982 z",
  },
  {
    id: "calves-gastroc-medial-left",
    name: "Gastrocnemius Medial Left",
    view: "back",
    path: "M 50.568,67.512 L 51.669,72.509 L 51.379,75.532 L 51.292,76.825 L 48.983,76.825 Z",
  },
  {
    id: "calves-gastroc-lateral-left",
    name: "Gastrocnemius Lateral Left",
    view: "back",
    path: "M 50.218,67.512 L 48.633,76.825 L 46.283,76.825 L 45.533,74.263 L 46.783,67.088 Z",
  },
  {
    id: "calves-soleus-left",
    name: "Soleus Left",
    view: "back",
    path: "M 46.386,77.175 L 51.269,77.175 L 50.701,85.598 L 49.037,86.233 Z",
  },
  {
    id: "calves-gastroc-medial-right",
    name: "Gastrocnemius Medial Right",
    view: "back",
    path: "M 54.628,67.512 L 53.526,72.509 L 53.816,75.532 L 53.903,76.825 L 56.213,76.825 Z",
  },
  {
    id: "calves-gastroc-lateral-right",
    name: "Gastrocnemius Lateral Right",
    view: "back",
    path: "M 54.978,67.512 L 56.563,76.825 L 58.912,76.825 L 59.662,74.263 L 58.412,67.088 Z",
  },
  {
    id: "calves-soleus-right",
    name: "Soleus Right",
    view: "back",
    path: "M 53.927,77.175 L 58.810,77.175 L 56.158,86.233 L 54.495,85.598 Z",
  },
  {
    id: "foot-back-left",
    name: "Left Foot (Back)",
    view: "back",
    path: "M 50.933115,88.340995 l 0.85194,1.3581 0.37189,0.79238 -0.15588,1.21774 -0.76984,0.74446 -1.51185,0.12543 -1.1299,-0.29192 -0.24225,-0.95894 0.80765,-1.30405 -0.22562,-0.85987 0.29679,-0.84153 -0.0194,-1.81524 1.53568,-0.54817 z m -1.19598,0.4675 0.15943,1.25776 -0.6023,0.97431 m -0.54436,0.29544 1.06474,0.40084 1.55326,-0.65137 z",
  },
  {
    id: "hamstrings-medial-left",
    name: "Medial Hamstrings (Semis) Left",
    view: "back",
    path: "M 49.550,50.504 L 51.751,49.461 L 52.389,49.692 L 52.424,51.499 L 52.499,56.145 L 50.521,62.188 L 50.997,63.602 L 49.569,66.897 L 48.755,66.754 Z",
  },
  {
    id: "hamstrings-lateral-left",
    name: "Lateral Hamstrings (Biceps) Left",
    view: "back",
    path: "M 49.400,50.496 L 48.605,66.746 L 47.803,66.596 L 47.302,64.480 L 47.133,62.723 L 44.712,54.565 L 44.369,50.918 L 47.200,51.500 Z",
  },
  {
    id: "foot-back-right",
    name: "Right Foot (Back)",
    view: "back",
    path: "M 54.262335,88.340995 l -0.85194,1.3581 -0.37189,0.79238 0.15589,1.21774 0.76983,0.74446 1.51186,0.12543 1.12989,-0.29192 0.24225,-0.95894 -0.80765,-1.30405 0.22563,-0.85987 -0.29679,-0.84153 0.0194,-1.81524 -1.53568,-0.54817 z m 1.19598,0.4675 -0.15943,1.25776 0.6023,0.97431 m 0.54436,0.29544 -1.06474,0.40084 -1.55326,-0.65137 z",
  },
  {
    id: "hamstrings-medial-right",
    name: "Medial Hamstrings (Semis) Right",
    view: "back",
    path: "M 57.425,51.196 L 56.565,66.806 L 55.759,66.965 L 54.331,63.670 L 54.807,62.256 L 52.829,56.213 L 52.904,51.567 L 52.956,49.769 L 53.520,49.498 Z",
  },
  {
    id: "hamstrings-lateral-right",
    name: "Lateral Hamstrings (Biceps) Right",
    view: "back",
    path: "M 57.575,51.204 L 60.625,50.950 L 60.616,54.633 L 58.195,62.791 L 58.026,64.547 L 57.525,66.663 L 56.715,66.814 Z",
  },
];
